import React from "react";
import Swal from "sweetalert2";
import axios from "axios";

const EditDeptModal = ({ isOpen, onClose, editFormData, setEditFormData, fetchData, branch }) => {
  if (!isOpen) return null;

  const handleEditChange = (e) => {
    const { name, value } = e.target;
    setEditFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleEditSubmit = async (e) => {
  e.preventDefault();

  // === Validation: Department Name ===
  if (!editFormData.deptName || editFormData.deptName.trim() === "") {
    Swal.fire({
      icon: "warning",
      title: "Validation Error",
      text: "Department Name should not be empty.",
    });
    return;
  }

  try {
    Swal.fire({
      title: "Submitting...",
      text: "Please wait while we process your request.",
      allowOutsideClick: false,
      didOpen: () => {
        Swal.showLoading();
      },
    });

    const response = await axios.put(
      `https://rfs2.infraconsoft.net.in/api/dept_update/${editFormData.deptCode}`,
      {
        deptName: editFormData.deptName,
        branch: branch,
        deptCode: editFormData.deptCode,
      }
    );

    // Success
    Swal.fire({
      icon: "success",
      title: "Updated!",
      text: response.data.message || "Department updated successfully.",
    });
    onClose();
    fetchData();
  } catch (error) {
    console.error("Error updating department:", error);

    if (error.response && error.response.data) {
      Swal.fire({
        icon: "error",
        title: "Error",
        text: error.response.data.message || "Update failed. Please try again.",
      });
    } else {
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Update failed. Please try again.",
      });
    }
  }
};


  return (
    <div className="modal">
      <div className="modal-content" style={{ position: "relative" }}>
        <div style={{ position: "absolute", top: "10px", right: "10px" }}>
          <button className="close-btn" onClick={onClose} style={{ position: "initial" }}>
            &times;
          </button>
        </div>
        <h3>Edit Department</h3>
        <form className="vehicle-form" onSubmit={handleEditSubmit}>
          <div className="form-row">
            <div className="form-group">
              <label>Department Code :</label>
              <input
                type="text"
                name="deptCode"
                value={editFormData.deptCode}
                onChange={handleEditChange}
                readOnly
              />
            </div>
          </div>

          <div className="form-row">
            <div className="form-group">
              <label>Department Name :</label>
              <input
                type="text"
                name="deptName"
                value={editFormData.deptName}
                onChange={handleEditChange}
              />
            </div>
          </div>

          <div className="btn-cls">
            <button type="submit" className="submit-btn">
              Save
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default EditDeptModal;
